/**
 * Error for a single state program operation.
 */
class StateProgramsError extends Error {
  /**
   * @param message describes the error (ex. "Failed to load metadata", "Could not initialize eligibility engine")
   * @param cause underlying error
   * @param programId Program ID that caused the error
   * @param programVersion Optional version ID that caused the error
   * @param visitId Optional visit ID that caused the error
   * @param providerId Optional provider ID that caused the error
   */
  constructor(
    message: string,
    public readonly cause: unknown,
    public readonly programId: string,
    public readonly programVersion?: string,
    public readonly visitId?: number,
    public readonly providerId?: number
  ) {
    const withVersion = programVersion ? ` with program version [${programVersion}]` : '';
    const withVisit = visitId ? ` with neighbor visit [${visitId}]` : '';
    const withProvider = providerId ? ` with provider [${providerId}]` : '';
    const fullMessage = `State program [${programId}]${withVersion}${withVisit}${withProvider}: ${message}`;
    super(fullMessage);
    this.name = 'StateProgramsError';
  }
}

export default StateProgramsError;
